<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row v-if="pagePrincipal" align="center" justify="center">
          <v-col cols="12" sm="12" md="9" lg="9">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img :src="empresa.logoUrl"  width="100%" style="max-width: 250px">
              </span>
              <v-card-actions style="padding: 0px; margin-top: 0px;">
                <v-container fluid grid-list-md >
                  <h3 style="margin-bottom: 10px; text-align: center;"><b>Eventos em cartaz</b></h3>
                  <v-layout row wrap justify-center v-if="eventos.length >= 1">
                      <v-container v-for="evento in eventos" :key="evento.id">
                          <v-row justify="center">
                            <v-col cols="12" sm="10" md="8" lg="6"> <!-- Ajuste os tamanhos de sm, md e lg conforme necessário -->
                              <v-card outlined class="mx-auto">
                                <v-img class="mx-auto" height="auto" width="100%" :src="evento.urlCapa"></v-img>
                                <v-card-title class=" mx-auto no-break">{{ evento.nome }}</v-card-title>
                                <v-card-text>
                                  <div>
                                    <v-icon>mdi-calendar</v-icon>
                                    {{ formatDateHora(evento.inicio) }}
                                  </div>
                                  <div style="margin-top: 5px">
                                    <v-icon>mdi-map-marker</v-icon>
                                    {{ evento.local }}
                                  </div>
                                  <div style="margin-top: 5px">
                                    <v-icon>mdi-ticket-confirmation</v-icon>
                                    {{ evento.exigePagamento ? 'R$ ' + evento.valor + ' (individual)' : 'Entrada franca' }}
                                  </div>
                                </v-card-text>
                                <v-card-actions class="justify-center">
                                  <v-btn dark color="#8E24AA" @click="realizarInscricaoGrupo(evento)">Inscrever agora</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-container>
                    <v-flex xs12 sm12 lg12>
                      <v-btn depressed block style="border-radius: 7px;" large :href="'https://wa.me/55' + empresa.telefone + '?text=Olá,%20pode%20me%20ajudar%20com%20os%20eventos%20da%20empresa%20' + empresa.nome + '?'" target="_blank">
                        <v-icon left>chat</v-icon>
                        Dúvidas? Fale Conosco!
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center v-else-if="eventos.length == 0">
                    <v-flex xs12 sm12 lg12>
                      <v-alert type="info">Nenhum evento em cartaz</v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- pagina pagamento -->
        <v-row v-if="pagePagamento" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img :src="empresa.logoUrl" width="100%" style="max-width: 300px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="indicacao">
                      <v-alert type="info">
                        Você está usando o link do divulgador {{ this.divulgador.nome }}
                      </v-alert>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha os dados do cartão de crédito:</p>
                    </v-flex>    
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="pagamento.nomeTitular" label="NOME IMPRESSO NO CARTÃO" single-line outlined color="#00695C" dense hide-details required v-validate="'required'" :error-messages="errors.collect('nomeCartao')" data-vv-name="nomeCartao"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light v-model="pagamento.cartaoNumero" v-mask="maskCartao" label="NÚMERO DO CARTÃO" single-line outlined color="#00695C" dense hide-details required v-validate="'required'" :error-messages="errors.collect('numCartao')" data-vv-name="numCartao"></v-text-field>
                    </v-flex> 
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-model="pagamento.cpfTitular" v-mask="mask" v-validate="'required|cpf'" :error-messages="errors.collect('cpftitular')" data-vv-name="cpftitular" label="CPF DO TITULAR" single-line outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>                  
                    <v-flex xs12 sm12 lg2>
                      <v-text-field light v-mask="'###'" v-model="pagamento.cvv" label="CVV" single-line outlined color="#00695C" dense hide-details type="password" required v-validate="'required'" :error-messages="errors.collect('codCartao')" data-vv-name="codCartao"></v-text-field>
                    </v-flex> 
                    <v-flex xs12 sm12 lg2>
                      <v-select outlined dense v-model="pagamento.mesVencimento" :items="mesesVencimento" hide-details item-text="titulo" item-value="id" color="#00695C" label="MÊS VENCIMENTO" v-validate="'required'" :error-messages="errors.collect('expiraCartaoMes')" data-vv-name="expiraCartaoMes"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-select outlined dense v-model="pagamento.anoVencimento" :items="anosVencimento" hide-details item-text="titulo" item-value="id" color="#00695C" label="ANO VENCIMENTO" v-validate="'required'" :error-messages="errors.collect('expiraCartaoAno')" data-vv-name="expiraCartaoAno"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-select outlined dense v-model="pagamento.bandeira" :items="bandeiras" hide-details item-text="text" item-value="value" color="#00695C" label="BANDEIRA" v-validate="'required'" :error-messages="errors.collect('bandeira')" data-vv-name="bandeira"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="pagamento.valor" :items="parcelas" hide-details item-text="text" item-value="value" color="#00695C" label="PARCELAS" v-validate="'required'" :error-messages="errors.collect('parcelas')" data-vv-name="parcelas" @input="carregaQtdParcelas"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha as informações de endereço e e-mail</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-mask="'#####-###'" v-model="pagamento.cep" label="CEP" single-line outlined type="tel" color="#00695C" dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field light v-model="pagamento.numero" label="NÚMERO DO ENDEREÇO" single-line outlined type="tel" color="#00695C" dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-text-field light v-model="pagamento.email" label="E-MAIL" single-line outlined color="#00695C" dense hide-details required v-validate="'required'"></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-left>
                    <v-flex xs10 sm10 lg12> 
                      <br>
                      <h2>Detalhes da Compra:</h2>
                    </v-flex>
                    <v-flex xs10 sm10 lg12> 
                      <h4 style="color:orange">{{cultoSelecionado}} R$ {{(parseFloat(valorEvento.replace(',','.')) + parseFloat(valorAcrescimo.acrescimoCartao1.replace(',','.'))).toFixed(2).replace('.',',')}}</h4>
                    </v-flex>
                    <v-flex xs10 sm10 lg12>
                      <h2 style="color:orange" v-if="textoParcela != '' && !caravana">{{ textoParcela }}</h2>
                      <h2 style="color:orange" v-if="textoParcela != '' && caravana">{{ textoParcela }} (referente a {{inscricao.participantes}} participantes)</h2>
                    </v-flex>
                    <!-- <v-flex xs10 sm10 lg12>
                      <qrcode-vue :value="'12456'" :size="size" level="H"></qrcode-vue>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" large @click="pagamentoCartao">Realizar Pagamento</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-btn dark depressed block color="#E53935" style="border-radius: 7px;" large @click="cancelarPagamento">Cancelar</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- pagina pagamento -->

        <!-- pagina consulta -->
        <v-row v-if="pageConsulta" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img :src="empresa.logoUrl" width="100%" style="max-width: 250px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>  
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Selecione o evento que você deseja consultar:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" color="#00695C"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha os dados abaixo para consultar a inscrição:</p>
                    </v-flex>   
                    <v-flex xs12 sm12 lg12 style="margin: 0 auto">
                      <v-text-field light label="CPF" color="#00695C" outlined v-mask="mask" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="cpf"></v-text-field>
                    </v-flex> 
                    <!-- <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="email" label="EMAIL" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg8>
                      <v-btn dark depressed block color="#00695C" style="border-radius: 7px;" large @click="consultarInscricao(cpf)">Consultar Inscrição</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- fim pagina consulta -->        
        <!-- PÁGINA INSCRIÇÃO GRUPO -->
        <v-row v-if="paginaInscricaoGrupo" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img :src="empresa.logoUrl" width="100%" style="max-width: 250px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="!bloqueiaVoltar">
                      <v-btn outlined @click="retornaPaginaPrincipal">
                        <v-icon left>mdi-arrow-left</v-icon>
                        Voltar
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Selecione o evento que você deseja participar:</p>
                    </v-flex> -->
                    <!-- <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" color="#00695C"></v-select>
                    </v-flex> -->
                    <!-- <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Quantidade:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-select v-model="quant" :items="quantidade" @input="verificaCapacidade()"></v-select>                              
                    </v-flex> -->
                  </v-layout>
                </v-container>                
                
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left style="margin-bottom: 20px">                
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Dados pessoais:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="eventoEspecifico">
                      <v-text-field light label="CPF" color="#00695C" outlined v-mask="mask" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="inscricao.cpf" @change="consultaCondicao"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-else>
                      <v-text-field light label="CPF" color="#00695C" outlined v-mask="mask" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="inscricao.cpf" @change="consultaInscricaoPendente()"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="inscricao.nome" label="NOME COMPLETO" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light label="DATA DE NASCIMENTO" color="#00695C" outlined v-mask="'##/##/####'" dense hide-details required type="tel" v-model="inscricao.dataNascimento"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-select outlined dense v-model="inscricao.sexo" :items="sexo" hide-details item-text="titulo2" item-value="id" color="#00695C" label="SEXO" :disabled="!eventoSelecionado.habilitaCampoSexo"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light label="WHATSAPP COM DDD" color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense required v-model="inscricao.telefone"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-select outlined dense v-model="inscricao.participantes" :items="quantidade" hide-details item-text="titulo2" item-value="id" color="#00695C" label="QUANTIDADE DE PARTICIPANTES"></v-select>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg6>
                      <v-text-field light v-model="inscricao.cidadeCaravana" label="INFORME A CIDADE E ESTADO" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg6>
                      <v-select outlined dense v-model="inscricao.possuiNecessidade" :items="condicoes" hide-details item-text="text" item-value="value" label="POSSUI ALGUMA NECESSIDADE ESPECIAL?" color="#00695C"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg6 v-if="inscricao.possuiNecessidade">
                      <v-select outlined dense v-model="inscricao.necessidadeEspecial" :items="necessidades" hide-details item-text="titulo2" item-value="id" label="INFORME A NECESSIDADE ESPECIAL" color="#00695C"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-checkbox v-model="inscricao.aceiteLgpd" style="margin-top: 10px">
                        <template v-slot:label>
                          <div>
                            Concordo com as <a target="_blank" href="https://2eea8b7d-a702-46f5-8be7-466aa412f79b.usrfiles.com/ugd/2eea8b_6acd8479401b41da80bfe3bbf2a0d37d.pdf" @click.stop>políticas de privacidade e tratamento de dados pessoais</a>
                          </div>
                        </template>
                      </v-checkbox>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg12>
                      <br>
                      <v-alert type="warning">
                        obs.: As pulseiras para acesso ao evento só serão entregues à <b>{{inscricao.nome}}</b>, responsável pelo grupo, mediante apresentação do seu documento com foto e QR Code desta compra.
                      </v-alert>
                    </v-flex> -->
                    <!-- <v-flex xs10 sm10 lg12>
                      <qrcode-vue :value="'12456'" :size="size" level="H"></qrcode-vue>
                    </v-flex> -->
                  </v-layout>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12>
                      <h2>Detalhes da Compra:</h2>
                    </v-flex>
                    <v-flex xs12 sm12 lg12> 
                      <h4 style="color:orange">{{cultoSelecionado}}</h4>
                    </v-flex>
                    <v-flex xs12 sm12 lg12> 
                      <h4 style="color:orange">
                        {{inscricao.participantes}} X R$ {{valorEvento}} = R$ {{ (parseFloat(valorEvento.replace(',','.')) * inscricao.participantes).toFixed(2).replace('.',',') }}
                      </h4>
                    </v-flex>
                  </v-layout>
                </v-container>             
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="realizarInscricaoPagamento">
                        <img style="margin-right: 5px" src="../../assets/credit-card.png" width="25px">
                        Cartão
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="realizarInscricaoPagamentoBoleto">
                        <img style="margin-right: 5px" src="../../assets/barcode.png" width="30px">
                        Boleto
                      </v-btn>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="realizarInscricaoPagamentoPix">
                        <img style="margin-right: 5px" src="../../assets/pix.png" width="20px">
                        Pix
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg3>
                      <v-btn dark depressed block color="#1565C0" style="border-radius: 7px;" large @click="realizarInscricaoPagamentoEmMaos">Pagar em Mãos</v-btn>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- PÁGINA INSCRIÇÃO GRUPO -->

        <v-row v-if="PageIncricao" align="center" justify="center">
          <v-col cols="12" sm="12" md="8" lg="8">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img :src="empresa.logoUrl" width="100%" style="max-width: 250px">
              </span>
              <v-card-text style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left>
                    <v-flex xs12 sm12 lg12 v-if="indicacao">
                      <v-alert type="info">
                        Você está usando o link do divulgador {{ this.divulgador.nome }}
                      </v-alert>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Selecione o evento que você deseja participar:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-select outlined dense v-model="eventoId" :items="eventos" item-text="nome" item-value="id" color="#00695C"></v-select>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Quantidade:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-select v-model="quant" :items="quantidade" @input="verificaCapacidade()"></v-select>                              
                    </v-flex> -->
                  </v-layout>
                </v-container>                
                
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-left style="margin-bottom: 20px">                
                    <v-flex xs12 sm12 lg12>
                      <p style="margin-bottom: 0px;">Preencha os dados:</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light label="CPF" color="#00695C" outlined v-mask="mask" dense hide-details required v-validate="'required|cpf'" :error-messages="errors.collect('cpf')" data-vv-name="cpf" type="tel" v-model="inscricao.cpf" @change="consultaInscricaoPendente()"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field light v-model="inscricao.nome" label="NOME COMPLETO" outlined color="#00695C" dense hide-details required></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light label="DATA DE NASCIMENTO" color="#00695C" outlined v-mask="'##/##/####'" dense hide-details required type="tel" v-model="inscricao.dataNascimento"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field light label="WHATSAPP COM DDD" color="#00695C" type="tel" outlined hide-details v-mask="'(##) #####-####'" dense required v-model="inscricao.telefone"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-select outlined dense v-model="inscricao.sexo" :items="sexo" hide-details item-text="titulo2" item-value="id" color="#00695C" label="SEXO" disabled></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg6>
                      <v-select outlined dense v-model="inscricao.possuiNecessidade" :items="condicoes" hide-details item-text="text" item-value="value" label="POSSUI ALGUMA NECESSIDADE ESPECIAL?"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg6 v-if="inscricao.possuiNecessidade">
                      <v-select outlined dense v-model="inscricao.necessidadeEspecial" :items="necessidades" hide-details item-text="titulo2" item-value="id" label="INFORME A NECESSIDADE ESPECIAL"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 lg12 v-if="usaCupomDesconto">
                      <v-switch :disabled="cupomAplicado" v-model="possuiCupom" inset label="Possui cupom de desconto?" color="#4FC3F7"></v-switch>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>
                      <v-text-field v-if="possuiCupom" :disabled="cupomAplicado" light label="Cupom de Desconto" color="#4FC3F7" outlined dense hide-details required v-model="cupomDesconto"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg2>
                      <v-btn v-if="possuiCupom" :loading="loadingCupom" :disabled="cupomAplicado" color="#4FC3F7" dark @click="aplicaCupom()">Aplicar</v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-chip v-if="cupomAplicado" class="ma-2" close color="orange" label outlined @click:close="removeCupom()">
                        Desconto de R${{dadosCupom.valor}} aplicado
                      </v-chip>
                    </v-flex>
                  </v-layout>
                </v-container>             
              </v-card-text>
              <v-card-actions style="padding: 0px">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click.once="realizarInscricaoPagamento">
                        <img style="margin-right: 5px" src="../../assets/credit-card.png" width="25px">
                        Cartão
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg4>
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="realizarInscricaoPagamentoBoleto">
                        <img style="margin-right: 5px" src="../../assets/barcode.png" width="30px">
                        Boleto
                      </v-btn>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg4 >
                      <v-btn depressed block outlined style="border-radius: 7px;" large @click="realizarInscricaoPagamentoPix">
                        <img style="margin-right: 5px" src="../../assets/pix.png" width="20px">
                        Pix
                      </v-btn>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg3>
                      <v-btn dark depressed block color="#1565C0" style="border-radius: 7px;" large @click="realizarInscricaoPagamentoEmMaos">Pagar em Mãos</v-btn>
                    </v-flex> -->
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <a href="https://www.intelitetecnologia.com.br/" target="_blank">
            <img src="../../assets/logoAIPassIntelite.png" width="250px">
          </a>
        </div>

        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">{{msgResultado}}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{inscricao.nome}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#EF6C00">Guarde esse código ou print essa imagem, será necessário para a sua identificação no dia do evento.</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{cultoSelecionado}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;" v-if="inscricao.participantes > 0">
                    <p class="texto" style="background-color: #D32F2F;color: white;" v-if="inscricao.participantes == 1">Ingresso para {{inscricao.participantes}} participante</p>
                    <p class="texto" style="background-color: #D32F2F;color: white;" v-if="inscricao.participantes > 1">Ingresso para {{inscricao.participantes}} participantes</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">SEU CÓDIGO É: <span style="color:#EF6C00">{{inscricao.cod_incricao}}</span></p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <qrcode-vue :value="inscricao.cod_incricao" :size="100" level="H"></qrcode-vue>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions style="padding-bottom: 0px" v-if="eventoSelecionado.usaCartaoConsumo || usaCartaoConsumo">
              <v-btn style="border-radius: 7px;" dark depressed block color="#474c56" :href="'https://aiconsumer.intelite.com.br?cod=' + inscricao.cod_incricao">Cartão Consumo</v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn style="border-radius: 7px;" dark depressed block color="#7b4f44" @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoBoleto" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">{{msgResultado}}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{inscricao.nome}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#FF0000">Fique atento! Após um dia útil, será enviada uma mensagem no WhatsApp do número informado com a confirmação de pagamento e o seu ingresso digital.</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{cultoSelecionado}}</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 2px;">
                    <v-btn style="border-radius: 7px;" dark depressed @click="abreBoleto">Visualizar Boleto</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#7b4f44" @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="confirmacaoEmMaos" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">{{msgResultado}}</span>
            </v-card-title>
            <v-card-text style="text-align: center; padding: 0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{inscricao.nome}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#FF0000">Sua inscrição foi pré-aprovada. Para confirmar, o pagamento deve ser feito em mãos.</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{cultoSelecionado}}</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#7b4f44" @click="closeDialog">fechar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCancelamento" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 8px;">
              <span class="texto">Solicitação de Cancelamento</span>
            </v-card-title>
            <v-card-text style="text-align: center;padding:0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">{{inscricao.nome}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="color:#00695C">CPF : {{inscricao.cpf}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto">{{cultoSelecionado}}</p>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding: 2px;">
                    <p class="texto" style="background-color: #D32F2F;color: white;">Confirme a sua solicitação de cancelamento</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="realizarCancelamento">confirmar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="pagamentoPix" persistent max-width="600px">
          <v-card style="border-radius: 10px;">
            <v-card-title style="justify-content: center; padding: 4px;">
              <span class="texto">{{msgResultado}}</span>
            </v-card-title>
            <v-card-title style="justify-content: center; padding: 4px;">
              <span class="texto">QR Code</span>
            </v-card-title>
            <v-card-text style="text-align: center;padding:0 24px 0;">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="12" style="padding: 1px;">
                    <v-card flat style="padding: 10px" color="white">
                      <img :src="qrCode64" width="100%" style="max-width: 300px">
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="12" md="12" style="padding: 1px;" v-if="valorAcrescimo.acrescimoPix && valorEvento">
                    <p v-if="caravana && (retornaData('MM') == '05' && parseInt(retornaData('D')) >= 8 && this.inscricao.participantes % 2 == 0)" class="texto" style="color:orange">Total a pagar: R$ {{(((parseFloat(this.valorEvento.replace(',','.')) - 5) + parseFloat(valorAcrescimo.acrescimoPix.replace(',','.'))) * inscricao.participantes).toFixed(2).replace('.',',')}}</p>
                    <p v-else class="texto" style="color:orange">Total a pagar: R$ {{((parseFloat(valorEvento.replace(',','.')) + parseFloat(valorAcrescimo.acrescimoPix.replace(',','.'))) * inscricao.participantes).toFixed(2).replace('.',',')}}</p>
                    <p v-if="caravana && (retornaData('MM') == '05' && parseInt(retornaData('D')) >= 8 && this.inscricao.participantes % 2 == 0)" class="texto" style="color:orange">Referente a {{inscricao.participantes + " inscrições de R$ " + ((parseFloat(this.valorEvento.replace(',','.')) - 5) + parseFloat(valorAcrescimo.acrescimoPix.replace(',','.'))).toFixed(2).replace('.',',')}} cada</p>
                    <p v-else class="texto" style="color:orange">R$ {{(parseFloat(valorEvento.replace(',','.')) + parseFloat(valorAcrescimo.acrescimoPix)).toFixed(2).replace('.',',')}}</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 1px;">
                    <p class="texto" style="color:#00695C" v-if="empresa.gatewayPagamentoPix == 'TAPAGO'">Nome Fantasia: INTELITE TECNOLOGIA FLAGSHIP</p>
                    <p class="texto" style="color:#00695C" v-else>Nome Fantasia: INTELITE TECNOLOGIA</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 1px;">
                    <p class="texto" style="color:#00695C">Solicitação Pagador: {{ empresa.nome }}</p>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 1px; position: absolute; left: -99999px;">
                    <v-text-field id="chavePix" v-model="chaveCopiaeCola"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12" style="padding: 1px;">
                    <v-btn dark depressed color="#00695C" @click="doCopy('chavePix')">Copiar Chave</v-btn>
                  </v-col>
                  <br>
                  <v-col cols="12" sm="12" md="12" style="padding: 1px;">
                    <p class="texto">Faça a leitura do QR Code ou copie a chave e cole no aplicativo de seu banco na função "Pix Copia e Cola". Realize o pagamento e aguarde a confirmação. Pode levar até 02 (dois) minutos.</p>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <!-- <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="closeDialog">Finalizar</v-btn>
            </v-card-actions> -->
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoToken" persistent max-width="400px">
          <v-card style="border-radius: 10px;">
            <v-card-text style="text-align: center; padding:0 24px 0;">
              <v-container>
                <p><b>Enviamos um token para seu WhatsApp.<br>Por favor, informe-o abaixo para ter acesso ao seu ingresso digital:</b></p>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="6" md="4" style="padding: 1px;">
                    <v-text-field light v-mask="'####'" v-model="token" label="TOKEN" type="tel" single-line outlined color="#00695C" dense hide-details required></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-container fluid grid-list-md>
                <v-spacer></v-spacer>
                <v-btn style="border-radius: 7px;" dark block depressed color="#00695C" @click="confirmaToken">Confirmar</v-btn>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoCondicoes" persistent max-width="400px">
          <v-card>
            <v-card-title>
              <p style="margin: 0px; font-weight: bold; color: orange">ATENÇÃO</p>
            </v-card-title>
            <v-card-text style="text-align: center">
              <v-icon size="100" color="orange">mdi-alert</v-icon>
              <h3>As condições da promoção não se enquadram para o CPF informado</h3>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="dialogoCondicoes = false; inscricao.cpf = ''">Inserir outro CPF</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  /* import vueCard from 'vue-card-express'; */
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import CpfValidate from '../../componentes/validators/rules/cpf'
  import QrcodeVue from 'qrcode.vue'
  import { baseApiUrl, /* modelBoleto */ } from '@/global'
  import Snackbar from '../../componentes/snackbar.vue'
  import {
    mapState
  } from 'vuex'
  import moment from 'moment'
  import axios from 'axios'
  export default {
    components: {
      Snackbar,
      QrcodeVue,
      Loading
    },
    name: 'Auth',
    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
    }),
    data: function () {
      return {
        timeout: 4000,
        snackbar: false,
        textoSnackbar: '',
        pagamentoPix: false,
        localPagamento: '',
        listCpf: [],
        eventoId: '',
        cpf: '',
        email: '',
        valorEvento: '0.00',
        /* parcelas: [1, 2, 3, 4, 5, 6], */
        quant: 1,
        pagePrincipal: true,
        pagePagamento: false,
        pageConsulta: false,
        PageIncricao: false,
        mask: "###.###.###-##",
        maskCartao: "#### #### #### ####",
        user: {},
        cultoSelecionado: '',
        inscricao: {
          cod_incricao: '',
          nome: '',
          email: '',
          cpf: '',
          sexo: 'FEMININO',
          telefone: '',
          eventoId: '',
          codigoTransacao: '',
          cardNumber: '',
          cardCvv: '',
          cardHolderName: '',
          cardValidity: '',
          cardFlag: '',
          valorPago: '',
          nsu: '',
          statusPagamento: '',
          boletoId: '',
          formOfPayment: '',
          situacaoBoleto: '',
          nossoNumero: '',
          vencimentoBoleto: '',
          infoVacina: '',
          participantes: 1,
          cidadeCaravana: '',
          lote: 0,
          dataNascimento: '',
          possuiNecessidade: false,
          necessidadeEspecial: '',
          visualizado: false,
          tipo: "VIRTUAL",
          aceiteLgpd: null,
        },
        inscricaoDefault: {
          cod_incricao: '',
          nome: '',
          email: '',
          cpf: '',
          sexo: 'FEMININO',
          telefone: '',
          eventoId: '',
          codigoTransacao: '',
          cardNumber: '',
          cardCvv: '',
          cardHolderName: '',
          cardValidity: '',
          cardFlag: '',
          valorPago: '',
          nsu: '',
          statusPagamento: '',
          boletoId: '',
          formOfPayment: '',
          situacaoBoleto: '',
          nossoNumero: '',
          vencimentoBoleto: '',
          infoVacina: '',
          participantes: 1,
          cidadeCaravana: '',
          lote: 0,
          dataNascimento: '',
          possuiNecessidade: false,
          necessidadeEspecial: '',
          visualizado: false,
          tipo: "VIRTUAL",
          aceiteLgpd: null,
        },
        pagamento: {
          valor: 0,
          cartaoNumero: '',
          cvv: '',
          mesVencimento: '',
          anoVencimento: '',
          nomeTitular: '',
          cpfTitular: '',
          bandeira: '',
          cep: '',
          numero: '',
          email: ''
        },
        dialogCancelamento: false,
        dialog: false,
        confirmacaoBoleto: false,
        confirmacaoEmMaos: false,
        qtdInscritos: 0,
        capacidadeEvento: 0,
        reserva: 0,
        sexo: ['MASCULINO', 'FEMININO'],
        tipo: ['MEMBRO', 'VISITANTE'],
        tamanhos: ['PP', 'P', 'M', 'G', 'GG', 'XG'],
        quantidade: [],
        mesesVencimento: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        anosVencimento: [],
        eventos: [],
        condicoes: [
          { value: true, text: 'SIM' },
          { value: false, text: 'NÃO' }
        ],
        necessidades: ['AUDITIVA', 'CADEIRANTE', 'VISUAL'],
        bandeiras: [
          {value: 'DINERS', text: "DINERS"},
          {value: 'ELO', text: "ELO"},
          {value: 'HIPERCARD', text: "HIPERCARD"},
          {value: 'MASTERCARD', text: "MASTERCARD"},
          {value: 'VISA', text: "VISA"}
        ],
        parcelas: [],
        modelCartao: {
          id: '',
          valor: '',
          tipoTransacao: 'A_VISTA',
          quantidadeParcelas: 1,
          comprador: {
            id: '',
            documentoNumero: '',
            documentoTipo: '1',
            email: '',
            nomeCompleto: '',
            primeiroNome: '',
            ultimoNome: '',
            enderecoLogradouro: '',
            enderecoNumero: '',
            enderecoComplemento: '',
            enderecoCep: '',
            enderecoBairro: '',
            enderecoCidade: '',
            enderecoEstado: '',
          },
          cartao: {
            numero: '',
            codigoSeguranca: '',
            nome: '',
            expiracaoAno: '',
            expiracaoMes: '',
            bandeira: ''
          }
        },
        cobrancaAsaas: {
          customer: '',
          billingType: '',
          value: 0,
          dueDate: '',
          description: ''
        },
        cobrancaAsaasCartao: {
          customer: '',
          billingType: '',
          value: 0,
          dueDate: '',
          description: '',
          remoteIp: '',
          creditCard: {
            holderName: '',
            number: '',
            expiryMonth: '',
            expiryYear: '',
            ccv: ''
          },
          creditCardHolderInfo: {
            name: '',
            email: '',
            cpfCnpj: '',
            postalCode: '',
            addressNumber: '',
            phone: ''
          }
        },
        clienteAsaas: {
          name: '',
          cpfCnpj: '',
          email: '',
          mobilePhone: '',
          postalCode: '',
          addressNumber: '',
          notificationDisabled: true,
        },
        tokenAsaas: '49c4e67d3ee1f8dc149532590589285abc97c9b10a8c3759e9b6f63e383a76d3',
        qrCode64: '',
        chaveCopiaeCola: '',
        empresa: [],
        isLoading: false,
        fullPage: true,
        jaExiste: false,
        codigoExistente: '',
        msgResultado: '',
        idInscricao: '',
        codigoAcesso: '',
        informaMunicipio: true,
        idClienteAsaas: '',
        valorAcrescimo: {
          acrescimoBoleto: 0.00,
          acrescimoPix: 0.00,
          acrescimoCartao1: 0.00,
          acrescimoCartao2: 0.00,
          acrescimoCartao3: 0.00,
          acrescimoCartao4: 0.00,
          acrescimoCartao5: 0.00,
          acrescimoCartao6: 0.00,
        },
        qtdInscMasculinas: 0,
        qtdInscFemininas: 0,
        vagasMasculinas: 0,
        vagasFemininas: 0,
        textoParcela: '',
        paginaInscricaoGrupo: false,
        caravana: false,
        inscricaoLocalizada: false,
        verificaCodInscricao: 0,
        linkBoleto: '',
        consultaCPF: false,
        dialogoToken: false,
        token: '',
        divulgador: [],
        indicacao: false,
        possuiCupom:false,
        cupomDesconto: '',
        cupomAplicado: false,
        loader: null,
        loadingCupom: false,
        dadosCupom: [],
        qtdParcelas: null,
        usaCupomDesconto: null,
        tipoIngresso: '',
        eventoSelecionado: [],
        usaCartaoConsumo: null,
        bloqueiaVoltar: false,
        eventoEspecifico: false,
        dialogoCondicoes: false,
        dictionary: {
          custom: {
            nomeCartao: {
              required: () => 'Informe o nome'
            },
            numCartao: {
              required: () => 'Informe o número do cartão de crédito',
            },
            cpftitular: {
              required: () => 'Informe o número do cartão de crédito',
            },
            codCartao: {
              required: () => 'Informe o código de segurança'
            },
            expiraCartaoMes: {
              required: () => 'Informe o mês de validade do cartão',
            },
            expiraCartaoAno: {
              required: () => 'Informe o ano de validade do cartão',
            },
            dateOfBirth: {
                required: () => 'Informe a Data de Nascimento' ,
                date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
            },
          }
        }
      }
    },
    
    mounted: function () {
      this.carregaDados(true)
      this.carregaEmpresa()
      this.$validator.localize('pt', this.dictionary)
    },

    watch: {
      /* 'inscricao.participantes'(value) {
        if (value >= 5) {
          this.valorEvento = this.eventoSelecionado.valorCaravana
        } else if (value < 5) {
          this.valorEvento = this.eventoSelecionado.valor
        }
      }, */
    },

    methods: {
      criarAnosVencimento() {
        this.anosVencimento = []
        let anoAtual = new Date().toISOString().substring(0, 4)
        let anoFinal = parseInt(new Date().toISOString().substring(0, 4)) + 14

        while ( anoAtual <= anoFinal ) {
          this.anosVencimento.push((anoAtual++).toString());
        }
      },

      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },

      reloadPage() {
        window.location.reload()
      },

      async carregaEmpresa() {
        await axios.get(`${baseApiUrl}Empresas/6228dc2f485a1235e92355d1?access_token=JFBsEGfdh12CYleCU6GSbyMPwovCHwf07lQfh9G9nX3GOqCIGNnX7FSGvdlu094F`).then(res => {
          if (res.data) {
            this.empresa = res.data
          }
        })
      },

      async carregaDados(criarQuantidades = false) {
        this.eventos = []
        this.isLoading = true
        await axios.get(`${baseApiUrl}Eventos?filter={"where":{"and":[{"empresaId":"6228dc2f485a1235e92355d1"},{"ativo":"true"}]}}`).then(res => {
          for (var key in res.data) {
            if (res.data.hasOwnProperty(key)) {
              if (moment(this.formatDateHora(res.data[key].fim), 'DD/MM/YYYY HH:mm:ss', true).format() >= moment().format()) {
                this.eventos.push(res.data[key])
                this.eventoId = res.data[key].id
                this.valorEvento = res.data[key].valor
                this.valorAcrescimo.acrescimoBoleto = res.data[key].acrescimoBoleto  
                this.valorAcrescimo.acrescimoPix = res.data[key].acrescimoPix  
                this.valorAcrescimo.acrescimoCartao1 = res.data[key].acrescimoCartao1
                this.valorAcrescimo.acrescimoCartao2 = res.data[key].acrescimoCartao2
                this.valorAcrescimo.acrescimoCartao3 = res.data[key].acrescimoCartao3
                this.valorAcrescimo.acrescimoCartao4 = res.data[key].acrescimoCartao4
                this.valorAcrescimo.acrescimoCartao5 = res.data[key].acrescimoCartao5
                this.valorAcrescimo.acrescimoCartao6 = res.data[key].acrescimoCartao6
                this.inscricao.lote = res.data[key].lote
                this.qtdParcelas = res.data[key].quantidadeParcelas
                this.usaCupomDesconto = res.data[key].usaCupomDesconto
              }
            }
          }
          this.eventos = this.eventos.sort(this.compare)
          this.isLoading = false
          if (criarQuantidades) {
            for (let i = 0; i < 51; i++) {
              if (i > 0) {
                this.quantidade.push(i)
              }
            }
            this.pegaParametrosUrl()
          }
        })
      },

      criarParcelas() {
        this.parcelas = []
        for (let i = 0; i < this.qtdParcelas; i++) {
          if (this.caravana) {
            this.parcelas.push({
              "text": i+1 + 'X de R$ ' + (((parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])) / (i + 1)) * parseFloat(this.inscricao.participantes)).toFixed(2).replace('.',',') + " (Total R$ " + ((parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])) * parseFloat(this.inscricao.participantes)).toFixed(2).replace('.',',') + ")",
              "value": ((parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])) * parseFloat(this.inscricao.participantes)).toFixed(2).replace(',','.')
            })
          } else {
            this.parcelas.push({
              "text": i+1 + 'X de R$ ' + ((parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])) / (i + 1)).toFixed(2).replace('.',',') + " (Total R$ " + (parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])).toFixed(2).replace('.',',') + ")",
              "value": (parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])).toFixed(2).replace(',','.')
            })
          }
        }
        /* for (let i = 0; i < this.parcelas.length; i++) {
          if (this.caravana) {
            this.parcelas[i].text = this.parcelas[i].text + (((parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])) / (i + 1)) * parseFloat(this.inscricao.participantes)).toFixed(2).replace('.',',') + " (Total R$ " + ((parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])) * parseFloat(this.inscricao.participantes)).toFixed(2).replace('.',',') + ")"
            this.parcelas[i].value = ((parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])) * parseFloat(this.inscricao.participantes)).toFixed(2).replace(',','.')
          } else {
            this.parcelas[i].text = this.parcelas[i].text + ((parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])) / (i + 1)).toFixed(2).replace('.',',') + " (Total R$ " + (parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])).toFixed(2).replace('.',',') + ")"
            this.parcelas[i].value = (parseFloat(this.valorEvento) + parseFloat(this.valorAcrescimo['acrescimoCartao' + (i + 1)])).toFixed(2).replace(',','.')
          }
        } */
      },

      cancelarPagamento () {
        //this.removeCupom()
        this.pagePagamento = false
        if (this.caravana) {
          this.paginaInscricaoGrupo = true
        } else {
          this.PageIncricao = true
        }
      },

      /* formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      }, */

      formatDatePadrao(date) {
        if (!date) return null

        const [day, month, year] = date.substr(0, 10).split('/')
        return `${year}-${month}-${day}` + " " + date.substr(11, 6)
      },

      formatDateBrz(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateHora(date) {
        if (!date) return null

        const [year, month, day] = date.substr(0, 10).split('-')
        return `${day}/${month}/${year}` + " " + date.substr(11, 8)
      },

      async acessaConsulta() {
        this.pagePrincipal = false
        this.pageConsulta = true
      },

      async solicitaCancelamento() {
        this.pagePrincipal = false
        this.pageConsulta = true
        if (this.inscricao.nome == '' || this.eventoId == '' || this.inscricao.cpf == '') {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha os campos: Evento, Nome e CPF para solicitar o cancelamento!", "ATENÇÃO")
        } else {
          this.isLoading = false
          this.dialogCancelamento = true
        }
      },

      async realizarCancelamento() {
        this.idInscricao = ''
        this.isLoading = true
        try {
          let res = await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"cpf":"${this.inscricao.cpf}"}]}}`)
          if (res.data[0].id) {
            this.idInscricao = res.data[0].id
          } else {
            this.isLoading = false
            this.dialogCancelamento = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
          }
        } catch (error) {
          this.isLoading = false
          this.dialogCancelamento = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível localizar a inscrição, verifique os dados e tente novamente!", "ATENÇÃO")
        }
        if (this.idInscricao != '') {
          try {
            let res = await axios.delete(`${baseApiUrl}Inscricoes/${this.idInscricao}`)
            if (res.data != '') {
              this.isLoading = false
              this.inscricao = Object.assign({}, this.inscricaoDefault)
              this.dialogCancelamento = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#0288D1", "Cancelamento realizado com sucesso!", "INFORMAÇÃO")
            } else {
              this.isLoading = false
              this.dialogCancelamento = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")
            }
          } catch (error) {
            this.isLoading = false
            this.dialogCancelamento = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Não foi possível realizar o cancelamento, verifique os dados e tente novamente!", "ATENÇÃO")
          }
        }
      },

      async aplicaCupom(){
        if(this.cupomDesconto != ''){
          try {
            let res = await axios.get(`${baseApiUrl}Cupons?filter[where][nome]=${this.cupomDesconto.toUpperCase().trim()}`)
              if(res.data[0].nome.toUpperCase() == this.cupomDesconto.toUpperCase().trim() && res.data[0].quantidade > res.data[0].utilizados){
                this.dadosCupom = res.data[0]                
                this.cupomAplicado = true                
                this.valorEvento = (parseFloat(parseFloat(this.valorEvento) - parseFloat(this.dadosCupom.valor)).toFixed(2)).replace('.',',')
              }
          } catch (error) {
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#F9A825", "Cupom inválido ou esgotado!", "ATENÇÃO")
          }
        }
      },

      removeCupom(){
        this.valorEvento = (parseFloat(parseFloat(this.valorEvento) + parseFloat(this.dadosCupom.valor)).toFixed(2)).replace('.',',')
        this.cupomAplicado = false
        this.dadosCupom = []
        this.possuiCupom = false
        this.cupomDesconto = ''
      },

      async atualizaCupomsUtilizados(){
        try {
          await axios.patch(`${baseApiUrl}Cupons/${this.dadosCupom.id}`, {"utilizados":this.dadosCupom.utilizados + 1} )
        } catch (error) {
          //
        }
      },

      carregaQtdParcelas() {
        for (let i = 0; i < this.parcelas.length; i++) {
          if (this.pagamento.valor == this.parcelas[i].value) {
            this.cobrancaAsaasCartao.installmentCount = parseInt(this.parcelas[i].text.substring(0,1))
            this.textoParcela = this.parcelas[i].text
          }
        }
      },

      async realizarInscricaoPagamento() {
        //await this.carregaDados()
        this.isLoading = true
        this.jaExiste = false
        var camposBranco = false
        this.inscricao.eventoId = this.eventoId
        var vm = this;
        if (await this.validaVagas()) {
          if (this.caravana) {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.participantes == '' || this.inscricao.dataNascimento == '' || !this.inscricao.aceiteLgpd) {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.criarAnosVencimento()
              this.criarParcelas()
              this.isLoading = false
              this.pagePrincipal = false;
              this.paginaInscricaoGrupo = false
              this.pagePagamento = true;
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          } else {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.dataNascimento == '') {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.criarAnosVencimento()
              this.criarParcelas()
              this.isLoading = false
              this.pagePrincipal = false;
              this.PageIncricao = false
              this.pagePagamento = true;
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          }
        }
      },

      async realizarInscricaoPagamentoBoleto() {
        //await this.carregaDados()
        this.isLoading = true
        this.jaExiste = false
        var camposBranco = false
        this.inscricao.eventoId = this.eventoId
        var vm = this;
        if (await this.validaVagas()) {
          if (this.caravana) {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.participantes == '' || this.inscricao.dataNascimento == '' || !this.inscricao.aceiteLgpd) {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.pagamentoBoleto()
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          } else {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.dataNascimento == '') {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.pagamentoBoleto()
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          }
        }
      },

      async realizarInscricaoPagamentoEmMaos() {
        //await this.carregaDados()
        this.isLoading = true
        this.jaExiste = false
        var camposBranco = false
        this.inscricao.eventoId = this.eventoId
        if(await this.validaVagas()){
        if(this.inscricao.dataNascimento != '' && this.calculateAge(this.formatDate(this.inscricao.dataNascimento)) < 16) 
          {
            this.isLoading = false
            var vm2 = this;
            vm2.$refs.chamaSnackbar.snack("#F9A825","Só é permitido a inscrição de maiores de 16 anos!","ATENÇÃO")
          }
        else
        {
          if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf)) {
            camposBranco = true
            this.isLoading = false
          }
          if (camposBranco) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
          } else {
            this.inscricao.statusPagamento = 'PENDENTE'
            this.inscricao.formOfPayment = 'EM MAOS'
            this.inscricao.valorPago = '330,00'
            this.realizarInscricao(this.finalizaInscricao)
          }
          if(this.inscricao.length == 0)
            this.isLoading = false
        }
        }
      },
      

      async realizarInscricaoPagamentoPix() {
        //await this.carregaDados()
        this.isLoading = true
        this.jaExiste = false
        var camposBranco = false
        this.inscricao.eventoId = this.eventoId
        var vm = this;
        if (await this.validaVagas()) {
          if (this.caravana) {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.participantes == '' || this.inscricao.dataNascimento == '' || !this.inscricao.aceiteLgpd) {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.empresa.gatewayPagamentoPix == 'TAPAGO' ? this.pagarPixTaPago() : this.pagarPixAsaas()
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          } else {
            if (this.inscricao.nome == '' || this.inscricao.cpf == '' || this.inscricao.telefone == '' || !CpfValidate(this.inscricao.cpf) || this.inscricao.dataNascimento == '') {
              camposBranco = true
              this.isLoading = false
            }
            if (camposBranco) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para confirmar a inscrição!", "ATENÇÃO")
            } else {
              this.empresa.gatewayPagamentoPix == 'TAPAGO' ? this.pagarPixTaPago() : this.pagarPixAsaas()
            }
            if (this.inscricao.length == 0)
              this.isLoading = false
          }
        }
      },

      realizarInscricaoAgora () {
        this.pagePrincipal = false;
        this.PageIncricao = true
        this.validaVagas()
        this.verificaCapacidade()
      },

      realizarInscricaoGrupo (evento) {
        this.tipoIngresso = evento.nome
        this.caravana = true
        this.pagePrincipal = false;
        this.paginaInscricaoGrupo = true
        this.eventoSelecionado = evento
        this.eventoId = evento.id
        this.valorEvento = evento.valor
        this.valorAcrescimo.acrescimoBoleto = evento.acrescimoBoleto  
        this.valorAcrescimo.acrescimoPix = evento.acrescimoPix  
        this.valorAcrescimo.acrescimoCartao1 = evento.acrescimoCartao1
        this.valorAcrescimo.acrescimoCartao2 = evento.acrescimoCartao2
        this.valorAcrescimo.acrescimoCartao3 = evento.acrescimoCartao3
        this.valorAcrescimo.acrescimoCartao4 = evento.acrescimoCartao4
        this.valorAcrescimo.acrescimoCartao5 = evento.acrescimoCartao5
        this.valorAcrescimo.acrescimoCartao6 = evento.acrescimoCartao6
        this.inscricao.lote = evento.lote
        this.qtdParcelas = evento.quantidadeParcelas
        this.usaCupomDesconto = evento.usaCupomDesconto
        this.validaVagas()
        this.verificaCapacidade()
      },

      /* calculateAge(dobString) {
        var dob = new Date(dobString);
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var birthdayThisYear = new Date(currentYear, dob.getMonth(), dob.getDate());
        var age = currentYear - dob.getFullYear();
        if(birthdayThisYear > currentDate) {
          age--;
        }
        return age;
      }, */

      async hasCpf(cpf) {
        this.jaExiste = false
        if (this.listCpf.includes(cpf)) {
          this.jaExiste = true
          this.inscricao.cpf = ''
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "CPF não pode ser o mesmo já informado!", "ATENÇÃO")
        } else {
          this.listCpf = this.inscricao.cpf
        }
        if (this.jaExiste == false) {
          await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.eventoId}`).then(res => {
            this.qtdInscritos = res.data.length
            if (res.data.length > 0) {
              for (var j = 0; j <= res.data.length - 1; j++) {                                 
                if (res.data[j].cpf == cpf) {
                  this.jaExiste = true
                  this.inscricao.cpf = ''
                  this.insricaoExistente = res.data[j]
                  this.codigoExistente = res.data[j].cod_incricao
                }             
              }
            }
          })
        }
        if (this.jaExiste) {
          this.msgResultado = 'Já existe um cadastro realizado para esse evento com o CPF informado'
          this.isLoading = false
        }
      },

      async validaVagas() {
        var vm = this;

        try {
          await axios.get(baseApiUrl + 'inscricoes/count?where={"and":[{"eventoId":"'+this.eventoId+'"},{"sexo":"MASCULINO"}]}').then(response => {
            if (response.data) {
              this.qtdInscMasculinas = response.data.count
            }
          })
          await axios.get(baseApiUrl + 'inscricoes/count?where={"and":[{"eventoId":"'+this.eventoId+'"},{"sexo":"FEMININO"}]}').then(response => {
            if (response.data) {
              this.qtdInscFemininas = response.data.count
            }
          })
          /* let res = await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.eventoId}`)
          if (res.data.length > 0)
            res.data.forEach(insc => {
              if (insc.sexo == 'MASCULINO')
                this.qtdInscMasculinas = this.qtdInscMasculinas + 1
              else if (insc.sexo == 'FEMININO')
                this.qtdInscFemininas = this.qtdInscFemininas + 1
            }); */
          
          if (this.inscricao.sexo == 'MASCULINO') {
            //this.qtdInscMasculinas = this.vagasMasculinas
            if (this.qtdInscMasculinas == this.vagasMasculinas) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas para homens foram esgotadas!", "INFORMAÇÃO")
              return false
            } else {
              this.isLoading = false
              return true
            }
          } else if (this.inscricao.sexo == 'FEMININO') {
            if (this.qtdInscFemininas == this.vagasFemininas) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas para mulheres foram esgotadas!", "INFORMAÇÃO")
              return false
            } else {
              this.isLoading = false
              return true
            }
          } else {
            this.isLoading = false
            return true
          }
        } catch (error) {
          //
        }
      },

      async realizarInscricao(callback = null) {
        this.isLoading = true
        let codInscricao = ''
        this.inscricao.detalhes = this.tipoIngresso
        while (this.inscricao.cod_incricao == '') {
          codInscricao = new Date().getTime().toString()
          await axios.get(`${baseApiUrl}inscricoes/count?where={"cod_incricao":"${codInscricao}"}`).then(response => {
            if (response.data.count == 0) {
              this.inscricao.cod_incricao = codInscricao
            }
          })
        }
        /* if (this.inscricao.cod_incricao == '') {
          // this.inscricao.cod_incricao = new Date().getTime().toString()
          await this.verificaCodigoInscricao()
        } */
        this.inscricao.eventoId = this.eventoId
        this.inscricao.email = this.inscricao.email.toLowerCase().trim()
        this.inscricao.statusPagamento = "PENDENTE"
        this.inscricao.uf = this.estadoSelecionado
        if (this.idInscricao) {
          this.inscricao.id = this.idInscricao
        }
        await axios.post(`${baseApiUrl}Inscricoes/replaceOrCreate`, this.inscricao).then(res => {
          this.idInscricao = res.data.id
          if (callback) {
            callback()
          }
        }).catch(() => {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar cadastro, tente novamente", "ERRO")
        })
      },

      async verificaCodigoInscricao() {
        this.verificaCodInscricao = setInterval(function() {
          this.inscricao.cod_incricao = new Date().getTime().toString()
          axios.get(`${baseApiUrl}inscricoes/count?where={"cod_incricao":"${this.inscricao.cod_incricao}"}`).then(response => {
            if (response.data.count == 0) {
              clearInterval(this.verificaCodInscricao)
            }
          })
        }.bind(this), 1000);
      },

      async atualizaInscricao(callback = null) {
        this.inscricao.id = this.idInscricao
        try {
          await axios.patch(`${baseApiUrl}Inscricoes`, this.inscricao )
          if (callback) {
            callback()
          }
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao atualizar cadastro, tente novamente", "DESCULPE")
        }
      },

      async enviaEmail () {
        try {
          await axios.post(`${baseApiUrl}Inscricoes/EnviaEmailInscrito`, {"inscricaoId": this.idInscricao} ).then(res => {
            if (res.data) {
              this.codigoAcesso = res.data.codigoAcesso
            }
          })
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao enviar e-mail, tente novamente", "DESCULPE")
        }
      },

      async realizarConsulta() {
        if(this.cpf == '') {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para realizar a consulta!", "ATENÇÃO")
        } else {
          this.isLoading = true  
          var cpfSemMascara = this.cpf.replaceAll('.', '').replaceAll('-', '')                            
          await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"or":[{"cpf":"${this.cpf}"}, {"cpf":"${cpfSemMascara}"}]}]}}`).then(res => {
            if (res.data != '') {
              if (res.data[0].statusPagamento == "PENDENTE") {
                this.msgResultado = 'Inscrição localizada'
                this.cultoSelecionado = this.eventos[0].nome
                this.isLoading = false
                this.inscricao.nome = res.data[0].nome
                this.inscricao.cpf = res.data[0].cpf
                this.inscricao.email = res.data[0].email
                this.inscricao.ddd = res.data[0].ddd
                this.inscricao.telefone = res.data[0].telefone
                this.inscricao.sexo = res.data[0].sexo
                this.inscricao.participantes = res.data[0].participantes
                var vm2 = this;
                vm2.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Volte para a tela inicial e clique em 'Faça sua inscrição agora'.", "ATENÇÃO")
              } else {
                if (res.data[0].statusPagamento == "PAGO") {
                  this.cultoSelecionado = this.eventos[0].nome
                  this.inscricao.nome = res.data[0].nome
                  this.inscricao.cod_incricao = res.data[0].cod_incricao
                  this.inscricao.email = res.data[0].email
                  this.inscricao.participantes = res.data[0].participantes
                  this.dialog = true
                  this.isLoading = false
                }
              }
            } else {
              this.isLoading = false
              vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825", "Não foi localizada inscrição para os dados informados!", "ATENÇÃO")
            }
          })       
        }
      },

      async consultaInscricaoPendente() {
        this.isLoading = true
        var cpfSemMascara = this.inscricao.cpf.replaceAll('.', '').replaceAll('-', '')                            
        await axios.get(`${baseApiUrl}Inscricoes?filter={"where":{"and":[{"eventoId":"${this.eventoId}"},{"or":[{"cpf":"${this.inscricao.cpf}"}, {"cpf":"${cpfSemMascara}"}]}]}, "include":"evento"}`).then(res => {
          if (res.data != '') {
            if (res.data[0].statusPagamento == "PENDENTE") {
              this.inscricaoLocalizada = true
              this.msgResultado = 'Inscrição localizada'
              this.cultoSelecionado = this.eventos[0].nome
              this.isLoading = false
              this.inscricao.nome = res.data[0].nome
              this.inscricao.cpf = res.data[0].cpf
              this.inscricao.email = res.data[0].email
              this.inscricao.telefone = res.data[0].telefone
              this.inscricao.sexo = res.data[0].sexo
              this.inscricao.dataNascimento = res.data[0].dataNascimento
              this.inscricao.cod_incricao = res.data[0].cod_incricao
              this.inscricao.categoria = res.data[0].categoria
              this.inscricao.participantes = res.data[0].participantes
              this.idInscricao = res.data[0].id
              var vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Para prosseguir, escolha uma forma de pagamento no final do formulário.", "ATENÇÃO")
            } else {
              if (res.data[0].statusPagamento == "PAGO") {
                this.inscricao.cod_incricao = res.data[0].cod_incricao
                this.cultoSelecionado = res.data[0].evento.nome
                this.inscricao.participantes = res.data[0].participantes
                this.inscricao.nome = res.data[0].nome
                this.codigoAcesso = res.data[0].codigoAcesso
                this.inscricao.email = res.data[0].email
                this.dialog = true
                this.isLoading = false
              }
            }
          } else {
            this.isLoading = false
            this.consultaDadosCpf(this.inscricao.cpf)
          }
        })
      },

      async consultaDadosCpf(cpf) {
        await axios.get(baseApiUrl + 'inscricoes?filter={"where":{"cpf":"'+cpf+'"}}')
        .then(response => {
          if (response.data) {
            this.inscricao.nome = response.data[0].nome.trim()
            this.inscricao.dataNascimento = response.data[0].dataNascimento
            this.inscricao.telefone = response.data[0].telefone
          }
        })
      },

      async verificaCapacidade() {
        this.isLoading = true
        //await this.carregaDados()
        for (var key in this.eventos) {
          if (this.eventos.hasOwnProperty(key)) {
            if (this.eventos[key].id == this.eventoId) {
              this.capacidadeEvento = this.eventos[key].vagas
              this.cultoSelecionado = this.eventos[key].nome
              this.vagasMasculinas = this.eventos[key].vagasMasculinas
              this.vagasFemininas = this.eventos[key].vagasFemininas
              this.reserva = this.eventos[key].reserva
            }
          }
        }
        await axios.get(baseApiUrl + 'inscricoes/count?where={"eventoId":"'+this.eventoId+'"}').then(response => {
          if (response.data) {
            this.qtdInscritos = response.data.length + this.reserva
          }
        })
        /* await axios.get(`${baseApiUrl}Inscricoes?filter[where][eventoId]=${this.eventoId}`).then(res => {
          this.qtdInscritos = res.data.length + this.reserva
          if (res.data.length > 0) {
            for (var j = 0; j <= res.data.length - 1; j++) {
              if (res.data[j].cpf == this.inscricao.cpf) {
                this.jaExiste = true
                this.insricaoExistente = res.data[j]
                this.codigoExistente = res.data[j].cod_incricao
              }
            }
          }
        }) */
        if (this.qtdInscritos + this.quant > this.capacidadeEvento && this.capacidadeEvento - this.qtdInscritos > 0) {
          this.isLoading = false
          this.quant = 1          
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, restam apenas " + (this.capacidadeEvento - this.qtdInscritos) + " vaga(s) disponível!", "INFORMAÇÃO")
          this.verificaCapacidade()
        } else if (this.qtdInscritos + this.quant > this.capacidadeEvento && this.capacidadeEvento - this.qtdInscritos == 0) {
          this.isLoading = false
          this.quant = 0          
          var vm2 = this;
          vm2.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas foram esgotadas!", "INFORMAÇÃO")
          this.verificaCapacidade()
        } else {
          this.isLoading = false
          /* this.inscricao = []
          for (let i = 0; i < this.quant; i++) {
            this.inscricao.push({
              nome: '',
              cpf: '',
              email: '',
              tipo: '',
              sexo: '',
              ddd: '',
              telefone: '',
              eventoId: ''
            })
          } */
        }
      },

      async verificaVagas() {
        var vm = this;
        await axios.post(`${baseApiUrl}eventos/vagas`, {"eventoId": this.eventoId}).then(response => {
          if (response.data) {
            if (this.caravana) {
              if (response.data.vagasRestantes < 2) {
                vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas foram esgotadas!", "INFORMAÇÃO")
                return false
              } else if (response.data.vagasRestantes < this.inscricao.participantes) {
                vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, restam apenas " + (response.data.vagasRestantes) + " vaga(s) disponível(is)!", "INFORMAÇÃO")
                return false
              }
            } else {
              if (response.data.vagasRestantes == 0) {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#0288D1", "Desculpe-nos, todas as vagas foram esgotadas!", "INFORMAÇÃO")
                return false
              }
            }
            return true
          }
        })
      },

      // método de pagamento
      /* async pagarCartao() {
        if ((this.pagamento.nomeTitular != '') && (this.pagamento.cartaoNumero != '') && (this.pagamento.cpfTitular != '') && (this.pagamento.cvv != '') && (this.pagamento.mesVencimento != '') && (this.pagamento.anoVencimento != '') && (this.pagamento.bandeira != '')) {
          await this.realizarInscricao()
          if (this.idInscricao) {
            this.isLoading = true
            var primeiroUltimoNome = this.inscricao.nome.trim().split(" ")
            this.modelCartao.id = this.encrypt(this.inscricao.cod_incricao.toString())
            this.modelCartao.tipoTransacao = 'A_VISTA'
            this.inscricao.valorPago = this.valorEvento
            this.modelCartao.valor = parseFloat(this.valorEvento.replace(',','.'))
            //dados do comprador
            this.modelCartao.comprador.id = this.encrypt(this.inscricao.cod_incricao.toString())
            this.modelCartao.comprador.documentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
            this.modelCartao.comprador.documentoTipo = '1'
            this.modelCartao.comprador.email = this.inscricao.email
            this.modelCartao.comprador.nomeCompleto = this.inscricao.nome
            this.modelCartao.comprador.primeiroNome = primeiroUltimoNome[0]
            this.modelCartao.comprador.ultimoNome = primeiroUltimoNome[primeiroUltimoNome.length - 1]
            this.modelCartao.comprador.enderecoLogradouro = "Rua Professor Joaquim Francisco Veloso Galvao"
            this.modelCartao.comprador.enderecoNumero = "1734"
            this.modelCartao.comprador.enderecoComplemento = "Igreja da Liberdade"
            this.modelCartao.comprador.enderecoCep = "58031130"
            this.modelCartao.comprador.enderecoBairro = "EXPEDICIONARIOS"
            this.modelCartao.comprador.enderecoCidade = "JOAO PESSOA"
            this.modelCartao.comprador.enderecoEstado = "PARAIBA"
            // this.modelCartao.comprador.telefone = this.financialManagers.cellPhone
            this.modelCartao.cartao.nome = this.pagamento.nomeTitular
            // this.modelCartao.cartao.numero = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
            this.modelCartao.cartao.codigoSeguranca = this.pagamento.cvv
            this.modelCartao.cartao.expiracaoMes = this.pagamento.mesVencimento
            this.modelCartao.cartao.expiracaoAno = this.pagamento.anoVencimento
            this.modelCartao.cartao.bandeira = this.pagamento.bandeira

            // dados para a inscrição
            this.inscricao.cardCvv = this.encrypt(this.pagamento.cvv.toString())
            this.inscricao.cardNumber = this.pagamento.cartaoNumero.replace(/[^\d]+/g,'')
            this.inscricao.cardValidity = this.pagamento.mesVencimento + this.pagamento.anoVencimento
            this.inscricao.cardHolderName = this.pagamento.nomeTitular
            this.inscricao.cardFlag = this.pagamento.bandeira
            this.atualizaInscricao()
            try {
              let res = await axios.post(`${baseApiUrl}Pagamentos/cartaocredito`, this.modelCartao) 
              if (res.data) {
                this.inscricao.codigoTransacao = res.data.transacao.autorizacaoCodigo
                this.inscricao.nsu = res.data.transacao.nsu
                this.inscricao.paymentId = res.data.pagamentoId
                this.inscricao.formOfPayment = 'CARTAO'
                this.inscricao.statusPagamento = "PAGO"
                await this.atualizaInscricao()
                this.finalizaInscricao()
              }
            } catch (error) {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao efetuar pagamento, " + error.response.data.error.mensagem,"DESCULPE!")
            }
          } else {
            this.isLoading = false
            var vm4 = this;
            vm4.$refs.chamaSnackbar.snack("#EF5350", "Falha ao realizar inscrição, tente novamente!", "DESCULPE")
          }
        } else {
          this.$validator.validateAll()
        }
      }, */

      /* async pagarBoleto() {
        await this.realizarInscricao()
        if (this.idInscricao) {
          this.isLoading = true
          // criando data de vencimeto do boleto
          var datapagvenc = new Date();
          datapagvenc.setDate(new Date().getDate())
          // criando nosso número
          var nossoNum = this.inscricao.cod_incricao.toString() + Math.floor(10 + Math.random() * 99999)
          // preencher o campos do modelBoleto
          modelBoleto.pagadorDocumentoNumero = this.inscricao.cpf.replace(/[^\d]+/g,'')
          modelBoleto.pagadorNome = this.inscricao.nome.substr(0, 39)
          modelBoleto.pagadorEndereco = "Prof Joaquim Francisco V. Galvao, 1734"
          modelBoleto.pagadorBairro = "EXPEDICIONARIOS"
          modelBoleto.pagadorCidade = "JOAO PESSOA"
          modelBoleto.pagadorUf = "PB"
          modelBoleto.pagadorCep = "58031130";
          modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
          modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
          // salvando o responsibility e o valor do boleto caso seja anual
          modelBoleto.valorNominal = parseFloat(this.valorEvento.replace(',','.'))
          modelBoleto.mensagem = 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
          modelBoleto.nsu = this.inscricao.cod_incricao
          modelBoleto.nossoNumero = nossoNum.substr(0,12)
          modelBoleto.seuNumero = nossoNum.substr(0,12)
          // gerando o Boleto e pegando o ID
          try {
            let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
            if (res.data != '') {
              this.inscricao.boletoId = res.data.id
              this.inscricao.formOfPayment = 'BOLETO'
              this.inscricao.situacaoBoleto = 'GERADO'
              this.inscricao.nsu = modelBoleto.nsu
              this.inscricao.nossoNumero = modelBoleto.nossoNumero
              this.inscricao.vencimentoBoleto = modelBoleto.dataVencimento
              this.inscricao.statusPagamento = 'PENDENTE'
              await this.atualizaInscricao()
              await this.imprimirBoleto()
              await this.finalizaInscricao()
            }
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar boleto. Tente novamente!","DESCULPE");
            this.close()                 
          }                
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      }, */

      async pagamentoCartao() {
        if ((this.pagamento.nomeTitular != '') && (this.pagamento.cartaoNumero != '') && (this.pagamento.cpfTitular != '') && (this.pagamento.cvv != '') && (this.pagamento.mesVencimento != '') && (this.pagamento.anoVencimento != '') && (this.pagamento.bandeira != '') && (this.pagamento.cep != '') && (this.pagamento.numero != '') && (this.pagamento.email != '') && (this.pagamento.valor != 0)) {
          this.isLoading = true
          this.inscricao.statusPagamento = 'PENDENTE'
          this.inscricao.formOfPayment = 'CARTAO'
          this.inscricao.valorPago = parseFloat(this.pagamento.valor).toFixed(2)
          this.inscricao.parcelas = this.textoParcela
          if (!this.inscricaoLocalizada) {
            await this.realizarInscricao()
          }
          await this.criarClienteAsaas()
          if (this.idInscricao) {
            try {
              this.cobrancaAsaasCartao.customer = this.idClienteAsaas
              this.cobrancaAsaasCartao.billingType = 'CREDIT_CARD'
              if (this.caravana) {
                this.cobrancaAsaasCartao.value = parseFloat(this.pagamento.valor)
                this.cobrancaAsaasCartao.installmentValue = parseFloat(parseFloat(this.cobrancaAsaasCartao.value) / this.cobrancaAsaasCartao.installmentCount)
              } else {
                this.cobrancaAsaasCartao.value = parseFloat(this.pagamento.valor)
                this.cobrancaAsaasCartao.installmentValue = parseFloat(parseFloat(this.pagamento.valor) / this.cobrancaAsaasCartao.installmentCount)
              }
              this.cobrancaAsaasCartao.dueDate = moment().format('YYYY-MM-DD')
              this.cobrancaAsaasCartao.description = 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
              this.cobrancaAsaasCartao.inscricaoId = this.idInscricao
              this.cobrancaAsaasCartao.empresaId = this.empresa.id
              axios.get(`https://api.ipify.org/?format=json`).then(res => {
                if (res.data) {
                  try {
                    this.cobrancaAsaasCartao.remoteIp = res.data.ip
                  } catch (error) {
                    this.cobrancaAsaasCartao.remoteIp = '127.0.0.1'
                  }
                } else {
                  this.cobrancaAsaasCartao.remoteIp = '127.0.0.1'
                }
              })
              // inserindo dados do cartão de crédito no objeto de pagamento
              this.cobrancaAsaasCartao.creditCard.holderName = this.pagamento.nomeTitular
              this.cobrancaAsaasCartao.creditCard.number = this.pagamento.cartaoNumero
              this.cobrancaAsaasCartao.creditCard.expiryMonth = this.pagamento.mesVencimento
              this.cobrancaAsaasCartao.creditCard.expiryYear = this.pagamento.anoVencimento
              this.cobrancaAsaasCartao.creditCard.ccv = this.pagamento.cvv
              // inserindo dados do responśavel do cartão de crédito no objeto de pagamento
              this.cobrancaAsaasCartao.creditCardHolderInfo.name = this.pagamento.nomeTitular
              this.cobrancaAsaasCartao.creditCardHolderInfo.email = this.pagamento.email.trim().toLowerCase()
              this.cobrancaAsaasCartao.creditCardHolderInfo.cpfCnpj = this.pagamento.cpfTitular
              this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode = this.pagamento.cep
              this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber = this.pagamento.numero
              this.cobrancaAsaasCartao.creditCardHolderInfo.phone = this.inscricao.telefone.replace(/[^\d]+/g,'')
              await axios.post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.cobrancaAsaasCartao).then(res => {
                if (res.data.cobranca.status == 'CONFIRMED') {
                  this.inscricao.formOfPayment = 'CARTAO'
                  this.inscricao.statusPagamento = "PAGO"
                  this.inscricao.codigoTransacao = res.data.cobranca.invoiceUrl
                  // this.inscricao.paymentId = res.data.id
                  this.atualizaInscricao(this.finalizaInscricao)
                  if(this.cupomAplicado)
                    this.atualizaCupomsUtilizados()
                }
              })
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Transação não autorizada. Verifique os dados informados e tente novamente ou utilize um outro cartão.","DESCULPE");
            }
          } else {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
          }
        } else {
          this.$validator.validateAll()
          vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Preencha todos os campos corretamente para continuar!", "ATENÇÃO")
        }
      },

      async criarClienteAsaas() {
        this.clienteAsaas.name = this.pagePagamento ? this.pagamento.nomeTitular : this.inscricao.nome
        this.clienteAsaas.cpfCnpj = this.pagePagamento ? this.pagamento.cpfTitular : this.inscricao.cpf
        this.clienteAsaas.email = this.pagamento.email
        this.clienteAsaas.mobilePhone = this.inscricao.telefone.replace(/[^\d]+/g,'')
        this.clienteAsaas.postalCode = this.pagamento.cep
        this.clienteAsaas.addressNumber = this.pagamento.numero
        this.clienteAsaas.empresaId = this.empresa.id
        try {
          await axios.post(`${baseApiUrl}Pagamentos/criarCliente`, this.clienteAsaas).then(response => {
            if (response.data) {
              this.idClienteAsaas = response.data.id
            }
          })
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      async pagamentoBoleto() {
        this.isLoading = true
        this.inscricao.statusPagamento = 'PENDENTE'
        this.inscricao.formOfPayment = 'BOLETO'
        this.inscricao.parcelas = 'A VISTA'
        if (this.caravana) {
          if (moment().format('MM') == '05' && parseInt(moment().format('D')) >= 8) {
            if (this.inscricao.participantes % 2 == 0) {
              this.inscricao.valorPago = (((parseFloat(this.valorEvento.replace(',','.')) - 5) + parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(',','.'))) * this.inscricao.participantes).toFixed(2)
            } else {
              this.inscricao.valorPago = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(',','.'))) * this.inscricao.participantes).toFixed(2)
            }
          } else {
            this.inscricao.valorPago = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(',','.'))) * this.inscricao.participantes).toFixed(2)
          }
        } else {
          this.inscricao.valorPago = (parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(',','.'))).toFixed(2)
        }
        if (!this.inscricaoLocalizada) {
          await this.realizarInscricao()
        }
        await this.criarClienteAsaas()
        if (this.idInscricao) {
          try {
            this.cobrancaAsaas.customer = this.idClienteAsaas
            if (this.caravana) {
              if (moment().format('MM') == '05' && parseInt(moment().format('D')) >= 8) {
                if (this.inscricao.participantes % 2 == 0) {
                  this.cobrancaAsaas.value = (((parseFloat(this.valorEvento.replace(',','.')) - 5) + parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(',','.'))) * this.inscricao.participantes).toFixed(2)
                } else {
                  this.cobrancaAsaas.value = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(',','.'))) * this.inscricao.participantes).toFixed(2)
                }
              } else {
                this.cobrancaAsaas.value = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(',','.'))) * this.inscricao.participantes).toFixed(2)
              }
            } else {
              this.cobrancaAsaas.value = (parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoBoleto.replace(',','.'))).toFixed(2)
            }
            this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
            this.cobrancaAsaas.billingType = 'BOLETO'
            this.cobrancaAsaas.description = 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
            this.cobrancaAsaas.inscricaoId = this.idInscricao
            this.cobrancaAsaas.empresaId = this.empresa.id
            await axios.post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.cobrancaAsaas).then(res => {
              if (res.data) {
                // this.inscricao.paymentId = res.data.id
                this.inscricao.codigoTransacao = res.data.cobranca.invoiceUrl
                this.atualizaInscricao(this.finalizaInscricao)
                // window.open(res.data.cobranca.bankSlipUrl)
                this.linkBoleto = res.data.cobranca.bankSlipUrl
                if(this.cupomAplicado)
                    this.atualizaCupomsUtilizados()
              }
            })
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Problema encontrado ao gerar o boleto. Tente novamente mais tarde.","DESCULPE");
          }
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      abreBoleto() {
        window.open(this.linkBoleto)
      },

      async pagarPixAsaas() {
        this.isLoading = true
        this.inscricao.statusPagamento = 'PENDENTE'
        this.inscricao.formOfPayment = 'PIX'
        this.inscricao.parcelas = 'A VISTA'
        if (this.caravana) {
          if (moment().format('MM') == '05' && parseInt(moment().format('D')) >= 8) {
            if (this.inscricao.participantes % 2 == 0) {
              this.inscricao.valorPago = (((parseFloat(this.valorEvento.replace(',','.')) - 5) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
            } else {
              this.inscricao.valorPago = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
            }
          } else {
            this.inscricao.valorPago = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
          }
        } else {
          this.inscricao.valorPago = (parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))).toFixed(2)
        }
        if (!this.inscricaoLocalizada) {
          await this.realizarInscricao()
        }
        await this.criarClienteAsaas()
        if (this.idInscricao) {
          try {
            this.cobrancaAsaas.customer = this.idClienteAsaas
            if (this.caravana) {
              if (moment().format('MM') == '05' && parseInt(moment().format('D')) >= 8) {
                if (this.inscricao.participantes % 2 == 0) {
                  this.cobrancaAsaas.value = (((parseFloat(this.valorEvento.replace(',','.')) - 5) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
                } else {
                  this.cobrancaAsaas.value = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
                }
              } else {
                this.cobrancaAsaas.value = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
              }
            } else {
              this.cobrancaAsaas.value = (parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))).toFixed(2)
            }
            this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
            this.cobrancaAsaas.billingType = 'PIX'
            this.cobrancaAsaas.description = 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
            this.cobrancaAsaas.inscricaoId = this.idInscricao
            this.cobrancaAsaas.empresaId = this.empresa.id
            await axios.post(`${baseApiUrl}Pagamentos/AsaasCobranca`, this.cobrancaAsaas).then(res => {
              if (res.data) {
                // this.inscricao.paymentId = res.data.id
                this.inscricao.codigoTransacao = res.data.cobranca.invoiceUrl
                this.qrCode64 = "data:image/jpeg;base64," + res.data.qrCode.encodedImage
                this.chaveCopiaeCola = res.data.qrCode.payload
                this.msgResultado = 'Pré-inscrição realizada com sucesso'
                this.pagamentoPix = true
                this.isLoading = false
                this.inscricao.id = this.idInscricao
                this.atualizaInscricao()
                this.consultaPagamentoPix(res.data.id)
                if(this.cupomAplicado)
                    this.atualizaCupomsUtilizados()
              }
            })
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao gerar pagamento. Tente novamente mais tarde.","DESCULPE");
          }
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      consultaPagamentoPix() {
        try {
          this.verificaPagamento = setInterval(function() {
            axios.post(`${baseApiUrl}Pagamentos/AsaasCobrancaConsulta`, {"inscricaoId": this.idInscricao, "empresaId": this.empresa.id}).then(res3 => {
              if (res3.data.status == 'RECEIVED') {
                this.inscricao.statusPagamento = "PAGO"
                this.isLoading = true
                this.atualizaInscricao(this.finalizaInscricao)
                clearInterval(this.verificaPagamento)
              }
            })
          }.bind(this), 5000)
        } catch (error) {
          clearInterval(this.verificaPagamento)
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Não foi possível verificar o pagamento, tente novamente!","DESCULPE");
        }
      },

      async pagarPixTaPago() {
        this.isLoading = true
        this.inscricao.statusPagamento = 'PENDENTE'
        this.inscricao.formOfPayment = 'PIX'
        this.inscricao.parcelas = 'A VISTA'
        if (this.caravana) {
          if (moment().format('MM') == '05' && parseInt(moment().format('D')) >= 8) {
            if (this.inscricao.participantes % 2 == 0) {
              this.inscricao.valorPago = (((parseFloat(this.valorEvento.replace(',','.')) - 5) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
            } else {
              this.inscricao.valorPago = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
            }
          } else {
            this.inscricao.valorPago = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
          }
        } else {
          this.inscricao.valorPago = (parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))).toFixed(2)
        }
        if (!this.inscricaoLocalizada) {
          await this.realizarInscricao()
        }
        if (this.idInscricao) {
          let dadosCobranca = {
            "empresaId": this.empresa.id,
            "inscricaoId": this.idInscricao,
            "valor": "",
            "descricao": 'Ref. ao evento ' + this.cultoSelecionado + " para a insc. de nº " + this.inscricao.cod_incricao
          }

          if (this.caravana) {
            if (moment().format('MM') == '05' && parseInt(moment().format('D')) >= 8) {
              if (this.inscricao.participantes % 2 == 0) {
                dadosCobranca.valor = (((parseFloat(this.valorEvento.replace(',','.')) - 5) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
              } else {
                dadosCobranca.valor = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
              }
            } else {
              dadosCobranca.valor = ((parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))) * parseFloat(this.inscricao.participantes)).toFixed(2)
            }
          } else {
            dadosCobranca.valor = (parseFloat(this.valorEvento.replace(',','.')) + parseFloat(this.valorAcrescimo.acrescimoPix.replace(',','.'))).toFixed(2)
          }

          await axios.post(baseApiUrl + 'Pagamentos/taPagoCobranca', dadosCobranca)
          .then(response => {
            if (response.data) {
              this.qrCode64 = "data:" + response.data.instantPayment.generateImage.mimeType + ";base64," + response.data.instantPayment.generateImage.imageContent
              this.chaveCopiaeCola = response.data.instantPayment.textContent
              this.msgResultado = 'Pré-inscrição realizada com sucesso'
              this.pagamentoPix = true
              this.isLoading = false
              this.inscricao.id = this.idInscricao
              this.atualizaInscricao()
              this.consultaPagamentoPixTaPago()
              if (this.cupomAplicado)
                this.atualizaCupomsUtilizados()
            }
          })
          .catch(() => {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao gerar pagamento. Tente novamente mais tarde.","DESCULPE");
          })
        } else {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Falha ao realizar inscrição, tente novamente!","DESCULPE");
        }
      },

      async consultaPagamentoPixTaPago() {
        try {
          this.verificaPagamento = setInterval(async function() {
            await axios.post(baseApiUrl + 'Pagamentos/taPagoCobrancaConsulta', {"inscricaoId": this.idInscricao, "empresaId": this.empresa.id}).then(res3 => {
              if (res3.data.status == 'APPROVED') {
                this.inscricao.statusPagamento = "PAGO"
                this.isLoading = true
                this.atualizaInscricao(this.finalizaInscricao)
                clearInterval(this.verificaPagamento)
              }
            })
          }.bind(this), 5000)
        } catch (error) {
          clearInterval(this.verificaPagamento)
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Não foi possível verificar o pagamento, tente novamente!","DESCULPE");
        }
      },

      async imprimirBoleto() {
        //Baixando Boleto PDF
        try {
          let res = await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.inscricao.boletoId}/imprimir`, { responseType: 'arraybuffer', headers: {
            Authorization: 'Bearer ' + this.token, //the token is a variable which holds the token
            'Content-type': 'application/pdf'
          }
          })
          if  (res.data) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [res.data],
              {type: 'application/pdf'}
            );
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute('download', 'boleto.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();
            //Open the URL on new Window
            window.open(fileURL);
            //exibe mensagem de conclusao
            this.isLoading = false
            this.dialogLoading = true
          }
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir boleto. Tente novamente ou entre em contato com a Intelite Tecnologia!","ERRO");
        }
      },

      finalizaInscricao() {
        this.isLoading = false
        if (this.inscricao.formOfPayment == 'CARTAO') {
          this.msgResultado = 'Compra realizada com sucesso!'
          this.dialog = true
        } else if (this.inscricao.formOfPayment == 'BOLETO'){
          this.msgResultado = 'Pré inscrição realizada com sucesso!'
          this.confirmacaoBoleto = true
        } else if (this.inscricao.formOfPayment == 'EM MAOS'){
          this.msgResultado = 'Pré inscrição realizada com sucesso!'
          this.confirmacaoEmMaos = true
        } else {
          this.pagamentoPix = false
          this.msgResultado = 'Compra realizada com sucesso!'
          this.dialog = true
        }
        this.carregaDados()
      },

      //Função para criptografia
      encrypt(text) {
        let crypto = require('crypto');
        let password = 'pxuelh2so839ljis';
        let iv = 'pxuelh2so839ljis';
        let cipher = crypto.createCipheriv('aes-128-cbc', password, iv);
        let encryptedData = cipher.update(text, 'utf8', 'Base64') + cipher.final('Base64');
        return encryptedData;
      },

      closeDialog() {
        this.dialog = false
        this.pagamentoPix = false
        if (!this.consultaCPF) {
          this.reloadPage()
        }
        this.$validator.reset()
        if (this.consultaCPF) {
          this.consultaCPF = false
          this.inscricao = Object.assign({}, this.inscricaoDefault)
        }
      },

      compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const dataA = a.fim;
        const dataB = b.fim;

        let comparison = 0;
        if (dataA > dataB) {
          comparison = 1;
        } else if (dataA < dataB) {
          comparison = -1;
        }
        return comparison;
      },

      calculateAge(dobString) {
        var dob = new Date(dobString);
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var birthdayThisYear = new Date(currentYear, dob.getMonth(), dob.getDate());
        var age = currentYear - dob.getFullYear();
        if (birthdayThisYear > currentDate) {
          age--;
        }
        return age;
      },

      formatDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
      },

      async pegaParametrosUrl() {
        this.isLoading = true
        var params = window.location.search.substring(1).split('&');
        if (params[0] != '') {
          var paramArray = {};                    // Criar objeto que vai conter os parametros
          for (var i=0; i<params.length; i++) {   // Passar por todos os parametros
            var param = params[i].split('=');     // Dividir os parametros chave e valor
            paramArray[param[0]] = param[1];      // Adicionar ao objeto criado antes
          }
          if (paramArray['cod']) {
            await axios.get(baseApiUrl + 'inscricoes?filter={"where":{"cod_incricao":"'+ paramArray['cod'] +'"}}').then(async response => {
              if (response.data) {
                if (response.data[0].statusPagamento == 'PAGO') {
                  await axios.get(baseApiUrl + 'eventos/' + response.data[0].eventoId)
                  .then(response => {
                    if (response.data) {
                      this.cultoSelecionado = response.data.nome
                      this.usaCartaoConsumo = response.data.usaCartaoConsumo
                    }
                  })
                  this.inscricao.nome = response.data[0].nome
                  this.inscricao.cod_incricao = response.data[0].cod_incricao
                  this.inscricao.email = response.data[0].email
                  this.inscricao.participantes = response.data[0].participantes
                  this.dialog = true
                  this.isLoading = false
                  this.salvaHoraVisualizacao(response.data[0].id)
                } else {
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#F9A825","Pagamento da inscrição não foi efetuado.","ATENÇÃO");
                }
              }
            })
            //this.consultarInscricao(paramArray['cpf'], paramArray['cod'])
          }
          if (paramArray['d']) {
            this.consultaDivulgador(paramArray['d'])
          }
          if (paramArray['e']) {
            await axios.get(baseApiUrl + 'eventos/' + paramArray['e'])
            .then(response => {
              if (response.data) {
                this.bloqueiaVoltar = true
                this.eventoEspecifico = true
                this.cultoSelecionado = response.data.nome
                this.vagasFemininas = response.data.vagasFemininas
                this.realizarInscricaoGrupo(response.data)
              }
            })
          }
        }
        this.isLoading = false
      },

      async salvaHoraVisualizacao(id) {
        await axios.patch(baseApiUrl + 'inscricoes/' + id, { "visualizado": true, "ultimaVisualizacao": moment().toISOString() })
      },

      async consultarInscricao(cpf, cod) {
        var vm = this;
        if (cpf) {
          this.isLoading = true
          let envio = {
            "eventoId": this.eventoId,
            "cpf": cpf,
            "enviaToken": true,
            "canalNotificacao": "ZAP",
            "cod_incricao": cod
          }
          try {
            await axios.post(`${baseApiUrl}inscricoes/consultarInscricao`, envio).then(response => {
              if (response.data.length > 0) {
                this.idInscricao = response.data
                this.dialogoToken = true
                this.consultaCPF = true
                this.isLoading = false
              }
            })
          } catch (error) {
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao consultar inscrição, tente novamente!","DESCULPE");
          }
        } else {
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe o CPF para consultar","ATENÇÃO");
        }
      },

      async confirmaToken() {
        var vm = this;
        if (this.token) {
          this.isLoading = true
          let confirmacao = {
            "token": this.token,
            "inscricaoId": this.idInscricao
          }
          await axios.post(`${baseApiUrl}inscricoes/confirmToken`, confirmacao)
          .then(response => {
            if (response.data) {
              if (response.data.statusPagamento == 'PAGO') {
                this.consultaCPF = true
                this.cultoSelecionado = this.eventos[0].nome
                this.inscricao.nome = response.data.nome
                this.inscricao.cod_incricao = response.data.cod_incricao
                this.inscricao.email = response.data.email
                this.inscricao.participantes = response.data.participantes
                this.dialogoToken = false
                this.token = ''
                this.dialog = true
                this.isLoading = false
                this.idInscricao = ''
              } else if (response.data.statusPagamento == 'PENDENTE') {
                this.inscricaoLocalizada = true
                this.consultaInscricao(this.idInscricao)
                if (response.data.participantes > 1) {
                  this.dialogoToken = false
                  this.isLoading = false
                  this.pageConsulta = false
                  this.realizarInscricaoGrupo()
                  vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.", "ATENÇÃO")
                } else {
                  this.dialogoToken = false
                  this.isLoading = false
                  this.pageConsulta = false
                  this.realizarInscricaoAgora()
                  vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação pendente de pagamento. Confirme as informações e, em seguida, escolha uma forma de pagamento desejada.", "ATENÇÃO")
                }
                this.token = ''
                this.idInscricao = ''
                this.inscricao = Object.assign({}, this.inscricaoDefault)
              } else if (response.data.statusPagamento == 'CANCELADO') {
                this.dialogoToken = false
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação cancelada.", "ATENÇÃO")
                this.token = ''
                this.idInscricao = ''
                this.inscricao = Object.assign({}, this.inscricaoDefault)
              } else if (response.data.statusPagamento == 'ESTORNADO') {
                this.dialogoToken = false
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#F9A825", "Foi localizada uma inscrição para este CPF com situação estornada.", "ATENÇÃO")
                this.token = ''
                this.idInscricao = ''
                this.inscricao = Object.assign({}, this.inscricaoDefault)
              }
            } else {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825", "Token inválido, tente novamente", "ATENÇÃO")
            }
          }).catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350", "Problema ao confirmar token, tente novamente", "DESCULPE")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("#F9A825", "Informe o token enviado para continuar", "ATENÇÃO")
        }
      },

      async consultaInscricao(id) {
        await axios.get(baseApiUrl + 'inscricoes/' + id)
        .then(response => {
          if (response.data) {
            this.inscricao.nome = response.data.nome
            this.inscricao.cpf = response.data.cpf
            this.inscricao.dataNascimento = response.data.dataNascimento
            this.inscricao.telefone = response.data.telefone
            this.inscricao.possuiNecessidade = response.data.possuiNecessidade
            this.inscricao.necessidadeEspecial = response.data.necessidadeEspecial
          }
        })
      },

      async consultaDivulgador(id) {
        await axios.get(baseApiUrl + 'Divulgadores/' + id).then(response => {
          if (response.data) {
            if (response.data.ativo) {
              this.indicacao = true
              this.divulgador = response.data
              this.inscricao.divulgadorId = this.divulgador.id
              axios.patch(baseApiUrl + 'Divulgadores/' + id, { "qtdClicks": response.data.qtdClicks ? response.data.qtdClicks + 1 : 1 })
            }
          }
        })
      },

      retornaData(tipo) {
        return moment().format(tipo)
      },

      retornaPaginaPrincipal() {
        this.eventoSelecionado = []
        this.inscricao = Object.assign({}, this.inscricaoDefault)

        if (this.PageIncricao) {
          this.PageIncricao = false
        } else {
          this.paginaInscricaoGrupo = false
        }
        
        this.pagePrincipal = true
      },

      async consultaCondicao() {
        var cpfSemMascara = this.inscricao.cpf.replaceAll('.', '').replaceAll('-', '')
        let vm = this
        this.isLoading = true

        await axios.get(baseApiUrl + 'inscricoes?filter={"where":{"and":[{"eventoId":"65426b5cf3d45356f1fed8dc"},{"or":[{"cpf":"' + this.inscricao.cpf + '"}, {"cpf":"' + cpfSemMascara + '"}]}]}, "include":"evento"}')
        .then(response => {
          if (response.data.length > 0) {
            if (response.data[0].statusPagamento == 'PAGO') {
              this.isLoading = false
              this.inscricao.nome = response.data[0].nome
              this.inscricao.dataNascimento = response.data[0].dataNascimento
              this.inscricao.telefone = response.data[0].telefone
              this.inscricao.possuiNecessidade = response.data[0].possuiNecessidade
            } else {
              this.isLoading = false
              this.dialogoCondicoes = true
            }
          } else {
            this.isLoading = false
            this.dialogoCondicoes = true
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("red","Problema ao buscar inscrição. Tente novamente!","DESCULPE");
        })
      },
    }
  }
</script>

<style scoped>
  /* LOGIN */

  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #424242, #616161);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  .no-break {
    word-wrap: normal;   /* Usamos 'normal' em vez de 'break-word' para impedir a quebra no meio de palavras */
    word-break: keep-all; /* Isso também ajuda a prevenir a quebra no meio de palavras */
    white-space: pre-line; /* Isto vai respeitar os espaços em branco e quebras de linha */
  }

  a {
    text-decoration: none
  }
</style>
